<template>
	<app-modal title="" @close="closeModal" @click.stop="">
		<template v-slot:header>
			<span class="mr-2"> Update "{{ category.menuCategory.categoryName }}" </span>
		</template>
		<div style="width: 350px;">
			<div class="flex flex-1 flex-col items-center justify-center mb-2 mx-2 px-2">
				<div class="flex flex-col mt-6">
					<form-title title="Target" />
					<div class="flex">
						<marketing-time-picker
							label="Time"
							:modelValue="getTimeFrom"
							@select="updateCategory('startDate', $event)"
						/>
						<marketing-time-picker
							label="-"
							label-class="text-right -ml-8"
							:modelValue="getTimeTo"
							@select="updateCategory('endDate', $event)"
						/>
					</div>
					<marketing-week-day-select
						:model-value="category.frequencies"
						@update:modelValue="$emit('updateFrequency', $event)"
					/>
					<app-checkbox
						label="Show Horizontal"
						:model-value="category.showHorizontal"
						@update:model-value="$emit('horizontalChange', $event)"
					/>
				</div>
			</div>
		</div>
		<div class="h-10 mt-3 flex justify-end">
			<app-button class="btn btn-success w-32" :loading="loading" @click="$emit('submit')">
				Save
			</app-button>
		</div>
	</app-modal>
</template>

<script>
	import AppCheckbox from '@/components/app/AppCheckbox.vue';
	import AppButton from '@/components/app/AppButton.vue';
	import MarketingWeekDaySelect from '@/components/marketing/forms/formComponents/MarketingWeekDaySelect.vue';
	import MarketingTimePicker from '@/components/marketing/forms/formComponents/MarketingTimePicker.vue';
	import AppModal from '@/components/app/AppModal.vue';

	export default {
		name: 'MenuFrequencyModal',
		components: { AppModal, MarketingTimePicker, MarketingWeekDaySelect, AppButton, AppCheckbox },
		data: () => ({
			categoryData: {},
		}),
		props: {
			category: {
				required: true,
				type: Object,
			},
		},
		methods: {
			closeModal() {
				this.$emit('close');
			},
			updateCategory(prop, value) {
				this.$emit('update:category', prop, value);
			},
		},
		computed: {
			getTimeFrom() {
				if (this.category.startDate?.length >= 10) return this.$filters.getShortTime(this.category.startDate);
				else return this.category.startDate;
			},
			getTimeTo() {
				if (this.category.endDate?.length >= 10) return this.$filters.getShortTime(this.category.endDate);
				else return this.category.endDate;
			},
		},
	};
</script>
